import { render, staticRenderFns } from "./Main.vue?vue&type=template&id=30bdea3e&scoped=true"
import script from "./Main.vue?vue&type=script&lang=js"
export * from "./Main.vue?vue&type=script&lang=js"
import style0 from "./Main.vue?vue&type=style&index=0&id=30bdea3e&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30bdea3e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('30bdea3e')) {
      api.createRecord('30bdea3e', component.options)
    } else {
      api.reload('30bdea3e', component.options)
    }
    module.hot.accept("./Main.vue?vue&type=template&id=30bdea3e&scoped=true", function () {
      api.rerender('30bdea3e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/scholarship/loadingProcess/Main.vue"
export default component.exports